<template>
  <div class="show-level-modal-page">
    <ModalShowLevel ref="modalRef" @closed="onModalClosed" />
  </div>
</template>

<script>
import ModalShowLevel from "@/modules/strategic_plans/components/ShowTree/ModalShowLevel.vue";

export default {
  name: "ShowLevelModalPage",
  components: { ModalShowLevel },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.$refs.modalRef?.show(id, this.$route.query.strategicPlanId || null);
    }
  },
  methods: {
    onModalClosed(strategicPlanId) {
      const id = strategicPlanId || this.$route.query.strategicPlanId;
      if (id) {
        this.$router.replace({
          name: "strategic_plans_show",
          params: { id },
        });
      } else {
        this.$router.replace({ name: "strategic_plans_list" });
      }
    },
  },
};
</script>
